import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Support from '../../../shared/Support';
import ReturnToMerchant from '../../../shared/ReturnToMerchant';

export default function Recharge({ merchant }) {
  return (
    <>
      <div className="text-xl font-avenir-black text-navy-blue mb-4">
        <p className="text-primary-blue text-3xl">
          <FontAwesomeIcon icon={['far', 'thumbs-up']} />
        </p>
        You're good to go!
      </div>

      <div className="max-w-[400px] mx-auto leading-7 ">
        <p>
          Your {merchant.name} rep will be able to see that you're now approved
          for Credit Key Recharge. They'll be able to place orders on your
          behalf, using your selected terms.
        </p>
      </div>
      <ReturnToMerchant merchant={merchant} />
      <Support />
    </>
  );
}
